import { h } from '@stencil/core';
import { Quiz } from '../../components';
import { findNearbyQuizQuestion } from '../utils/quiz-handler';
import { QuizQuestion } from '../../types/videoPlayer';
interface QuizNotificationProps {
  quizzes: Quiz;
  showQuiz: boolean;
  currentTime: number;
  answered: { quizQuestion: QuizQuestion; answer: string[] }[];
  onClick: (quiz: QuizQuestion, quizzes: Quiz) => void;
  pollPosition: 'top-left' | 'top-center' | 'top-right' | null;
}

export const QuizNotification = ({ quizzes, showQuiz, currentTime, answered, onClick, pollPosition }: QuizNotificationProps) => {
  const nearbyQuiz: QuizQuestion | undefined = findNearbyQuizQuestion(quizzes, currentTime, answered);

  if (!nearbyQuiz || showQuiz) return null;

  const position =
    !nearbyQuiz.position || nearbyQuiz.position === 'top-center'
      ? !!pollPosition && pollPosition === 'top-right'
        ? 'left'
        : 'right'
      : (nearbyQuiz.position ?? '').replace('top-', '');
  const bgColor = getComputedStyle(document.documentElement).getPropertyValue('--vp-video-text').trim();

  function triggerQuiz() {
    const quizQuestions = quizzes.quizQuestions.map(quiz => {
      if (quiz.id === quiz.id) {
        return { ...quiz, autoTrigger: false, triggered: true };
      }
      return quiz;
    });
    onClick(nearbyQuiz, { ...quizzes, quizQuestions });
  }

  if (nearbyQuiz.autoTrigger && !nearbyQuiz?.triggered) {
    triggerQuiz();
    return null;
  }

  return (
    <div class="quiz-notification-container" style={{ [position]: '16px' }} onClick={triggerQuiz}>
      <div class="quiz-info-icon">
        <svg width="24" height="24" viewBox="0 0 24 24" fill={bgColor}>
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" />
        </svg>
      </div>
      {!nearbyQuiz?.triggered && (
        <div class="quiz-alert-strip" style={{ [position]: '40px' }}>
          Quiz available! Click to participate.
        </div>
      )}
    </div>
  );
};
